<template>
  <b-modal
    id="level-kpi-form-modal"
    :title="`${kpi ? 'Update' : 'Create New'} KPI`"
    hide-footer
    size="xl"
    no-close-on-backdrop
    @hidden="formData = LEVEL_KPI_FORM_SNAPSHOT()"
    @shown="modalOpenHandler"
  >
    <b-form
      novalidate
      @submit.prevent="submitForm"
    >
      <validation-observer ref="formRef">
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name En"
              rules="required"
            >
              <b-form-group
                label="Name En"
                label-for="team-level-name-en"
              >
                <b-form-input
                  id="team-level-name-en"
                  v-model="formData.name.en"
                  placeholder="Name En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name Ar"
              rules="required"
            >
              <b-form-group
                label="Name Ar"
                label-for="team-level-name-ar"
              >
                <b-form-input
                  id="team-level-name-ar"
                  v-model="formData.name.ar"
                  placeholder="Name Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description En"
              rules="required"
            >
              <b-form-group
                label="Description En"
                label-for="team-level-kpi-description-en"
              >
                <b-form-textarea
                  id="team-level-kpi-description-en"
                  v-model="formData.description.en"
                  placeholder="description En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description Ar"
              rules="required"
            >
              <b-form-group
                label="Description Ar"
                label-for="team-level-kpi-description-ar"
              >
                <b-form-textarea
                  id="team-level-kpi-description-ar"
                  v-model="formData.description.ar"
                  placeholder="description Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <validation-provider
              #default="{ errors }"
              name="Effective Time"
              rules="required"
            >
              <b-form-group
                label="Effective Time"
                label-for="effective-time"
              >
                <b-form-datepicker
                  id="effective-time"
                  v-model="formData.effectiveTime"
                  :min="new Date()"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <b-form-group label="KPI Type">
              <b-form-radio-group
                v-model="formData.kpiType"
                class="mb-1"
                :options="KPI_TYPES"
                :disabled="!!kpi"
                @change="kpiTypeChangeHandler"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="formData.kpiType === KPI_TYPE.NUMBER_OF_TRIPS"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="No. of trips"
              rules="required"
            >
              <b-form-group
                label="No. of trips"
                label-for="number-of-trips"
              >
                <b-form-input
                  id="number-of-trips"
                  v-model.number="formData.configuration.numberOfTrips"
                  placeholder="No. of trips"
                  type="number"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <template v-else>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Min Rating"
                rules="required"
              >
                <b-form-group
                  label="Min Rating"
                  label-for="min-rating"
                >
                  <b-form-input
                    id="min-rating"
                    v-model.number="formData.configuration.minRating"
                    placeholder="Min Rating"
                    type="number"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Max low rated trips"
                rules="required"
              >
                <b-form-group
                  label="Max low rated trips"
                  label-for="max-low-rated-trips"
                >
                  <b-form-input
                    id="max-low-rated-trips"
                    v-model.number="formData.configuration.maxLowRatedTrips"
                    placeholder="Max low rated trips"
                    type="number"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </template>
          <b-col md="12">
            <b-form-group label="Period Type">
              <b-form-radio-group
                id="period"
                v-model="formData.configuration.period"
                class="mb-1"
                :options="PERIOD_OPTIONS"
                :disabled="!!kpi"
                @change="periodChangeHandler"
              />
            </b-form-group>
          </b-col>
          <template v-if="formData.configuration.period == PERIOD_TYPES.WEEKLY">
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Week Start Day"
                rules="required"
              >
                <b-form-group
                  label="Week Start Day"
                  label-for="week-start-day"
                >
                  <b-form-select
                    id="week-start-day"
                    v-model="formData.configuration.weekStartDay"
                    placeholder="Week Start Day"
                    :options="fromWeekDays"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Week End Day"
              >
                <b-form-group
                  label="Week End Day"
                  label-for="week-end-day"
                >
                  <b-form-select
                    id="week-end-day"
                    v-model="formData.configuration.weekEndDay"
                    :disabled="!formData.configuration.weekStartDay"
                    placeholder="Week End Day"
                    :options="toWeekDays"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col> -->
          </template>
          <template v-if="formData.configuration.period == PERIOD_TYPES.DAILY">
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="From Hour"
                rules="required"
              >
                <b-form-group
                  label="From Hour"
                  label-for="daily-from-hour"
                >
                  <b-form-input
                    id="daily-from-hour"
                    v-model="formData.configuration.fromHour"
                    placeholder="From Hour"
                    type="number"
                  />
                  <!-- @input="fromHoursChangeHandler" -->
                  <small class="text-muted">This field requires time to be entered in 24-hour format.</small>

                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="To Hour"
                rules="required"
              >
                <b-form-group
                  label="To Hour"
                  label-for="daily-to-hour"
                >
                  <b-form-input
                    id="daily-to-hour"
                    v-model="formData.configuration.toHour"
                    placeholder="To Hour"
                    type="number"
                  />
                  <small class="text-muted">This field requires time to be entered in 24-hour format.</small>
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </template>
          <b-col
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Duration"
              rules="required"
            >
              <b-form-group
                label="Duration"
                label-for="daily-duration"
              >
                <b-form-input
                  id="daily-duration"
                  v-model.number="formData.configuration.duration"
                  placeholder="Duration"
                  type="number"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <b-form-group label="Time Intervals">
              <div
                v-for="(interval, index) in formData.configuration.timeIntervals"
                :key="index"
                class="d-flex align-items-center mb-2"
              >
                <b-form-input
                  v-model.number="interval.fromHour"
                  type="number"
                  min="0"
                  max="24"
                  placeholder="From Hour"
                  class="mr-2"
                />
                <b-form-input
                  v-model.number="interval.toHour"
                  type="number"
                  min="0"
                  max="24"
                  placeholder="To Hour"
                  class="mr-2"
                />
                <b-button
                  variant="danger"
                  size="sm"
                  @click="removeInterval(index)"
                >
                  Delete
                </b-button>
              </div>

              <b-button
                variant="success"
                size="sm"
                @click="addInterval"
              >
                Add Interval
              </b-button>

              <small class="text-muted d-block mt-1">
                Hours must be between 0–24 (24-hour format).
              </small>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              type="submit"
              variant="primary"
              :disabled="submitting"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BRow,
  BCol,
  BModal,
  BFormDatepicker,
  BFormRadioGroup,
  BFormTextarea,
  BFormSelect,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, maxValue } from '@validations'
import { ref, set } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

const PERIOD_TYPES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
}

const KPI_TYPE = {
  NUMBER_OF_TRIPS: 'NUMBER_OF_TRIPS',
  RATING: 'RATING',
}

const PERIOD_OPTIONS = [
  {
    text: 'Monthly',
    value: PERIOD_TYPES.MONTHLY,
  },
  {
    text: 'Weekly',
    value: PERIOD_TYPES.WEEKLY,
  },
  {
    text: 'Daily',
    value: PERIOD_TYPES.DAILY,
  },
]

const KPI_TYPES = [
  {
    text: 'Number Of Trips',
    value: KPI_TYPE.NUMBER_OF_TRIPS,
  },
  {
    text: 'Rating',
    value: KPI_TYPE.RATING,
  },
]

const LEVEL_KPI_FORM_SNAPSHOT = () => JSON.parse(JSON.stringify({
  levelId: null,
  kpiType: KPI_TYPE.NUMBER_OF_TRIPS,
  name: {
    en: null,
    ar: null,
  },
  description: {
    en: null,
    ar: null,
  },
  configuration: {
    period: PERIOD_TYPES.MONTHLY,
    numberOfTrips: null,
    minRating: null,
    maxLowRatedTrips: null,
    timeIntervals: [],
  },
}))

export default {
  components: {
    BFormSelect,
    BModal,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormTextarea,
    BSpinner,
    BButton,
    BFormRadioGroup,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    kpi: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const fromWeekDays = ref(
      Array.from({ length: 7 }, (_, i) => ({
        value: i,
        text: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][i],
      })),
    )

    const toWeekDays = ref(
      Array.from({ length: 7 }, (_, i) => ({
        value: i,
        text: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][i],
        disabled: false,
      })),
    )

    const levelID = ctx.root.$route.params.id
    const submitting = ref(false)

    const formData = ref(LEVEL_KPI_FORM_SNAPSHOT())

    const formRef = ref(null)

    const submitForm = async () => {
      const res = await formRef.value.validate()
      if (!res) return

      const PAYLOAD = JSON.parse(JSON.stringify(formData.value))
      if (PAYLOAD.configuration.period === PERIOD_TYPES.DAILY) {
        PAYLOAD.configuration.fromHour = +PAYLOAD.configuration.fromHour
        PAYLOAD.configuration.toHour = +PAYLOAD.configuration.toHour
      }
      PAYLOAD.effectiveTime = new Date(formData.value.effectiveTime)
      try {
        submitting.value = true
        if (props.kpi) {
          await axiosIns.patch(`/teams/kpis/${props.kpi.id}`, {
            ...PAYLOAD,
            levelId: levelID,
          })
        } else {
          await axiosIns.post('/teams/kpis', {
            ...PAYLOAD,
            levelId: levelID,
          })
        }
        ctx.root.$bvModal.hide('level-kpi-form-modal')
        ctx.emit('refetch')
      } catch (err) {
        console.log(err?.response)
        errorNotification('An Error Occured')
      } finally {
        submitting.value = false
      }
    }

    const periodChangeHandler = type => {
      if (type === PERIOD_TYPES.WEEKLY) {
        set(formData.value.configuration, 'weekStartDay', null)
        set(formData.value.configuration, 'duration', null)
      } else {
        set(formData.value.configuration, 'fromHour', null)
        set(formData.value.configuration, 'toHour', null)
        set(formData.value.configuration, 'duration', null)
      }
    }

    const kpiTypeChangeHandler = () => {
      formData.value.configuration.numberOfTrips = null
      formData.value.configuration.minRating = null
      formData.value.configuration.maxLowRatedTrips = null
    }

    // const weekStartDayChangeHandler = val => {
    //   if (val >= formData.value.configuration.weekEndDay) {
    //     formData.value.configuration.weekEndDay = null
    //   }
    // }

    const modalOpenHandler = () => {
      toWeekDays.value = Array.from({ length: 7 }, (_, i) => ({
        value: i,
        text: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][i],
        disabled: false,
      }))

      if (props.kpi) {
        formData.value = JSON.parse(JSON.stringify(props.kpi))
        if (!formData.value.configuration.timeIntervals) {
          set(formData.value.configuration, 'timeIntervals', [])
        }
        formData.value.effectiveTime = new Date(props.kpi.effectiveTime)
      }
    }

    const addInterval = () => {
      formData.value.configuration.timeIntervals.push({ fromHour: null, toHour: null })
    }

    const removeInterval = index => {
      formData.value.configuration.timeIntervals.splice(index, 1)
    }

    return {
      maxValue,
      submitting,
      formRef,
      PERIOD_OPTIONS,
      submitForm,
      fromWeekDays,
      PERIOD_TYPES,
      toWeekDays,
      formData,
      modalOpenHandler,
      LEVEL_KPI_FORM_SNAPSHOT,
      required,
      addInterval,
      removeInterval,
      periodChangeHandler,
      // weekStartDayChangeHandler,
      KPI_TYPE,
      kpiTypeChangeHandler,
      KPI_TYPES,
    }
  },
}
</script>

    <style></style>
